import registerRootComponent from 'expo/build/launch/registerRootComponent';

// Root App registry
import App from './App';

registerRootComponent(App);